import { fromJS } from 'immutable';
import {
  SET_MANAGER_OPENED_CLAIMS,
  SET_SAGIS_LAWYER_ASSIGNED_CLAIMS,
} from 'containers/ManagerOpenedClaimsPage/constants';
import {
  RESET_STORE_OPENED_CLAIMS,
  RESET_STORE,
} from 'containers/LoginPage/constants';
import { OpenedClaimsReducerInterfaceAction } from 'containers/ManagerOpenedClaimsPage/typings';
import { get } from 'lodash';
import { SET_SEARCH } from 'containers/ValidatedClaimsPage/constants';

const initialState = fromJS({
  claims: [],
  countClaims: 0,
  sagisLawyerAssignedClaims: [],
});

const managerOpenedClaimsReducer = (
  state = initialState,
  action: OpenedClaimsReducerInterfaceAction,
) => {
  switch (action.type) {
    case SET_MANAGER_OPENED_CLAIMS:
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case SET_SAGIS_LAWYER_ASSIGNED_CLAIMS:
      return state.set(
        'sagisLawyerAssignedClaims',
        fromJS(get(action.response, 'data.claims')),
      );
    case SET_SEARCH:
      return state
        .set('claims', fromJS(action.data))
        .set('countClaims', fromJS(get(action, 'data', []).length));
    case RESET_STORE_OPENED_CLAIMS:
      return initialState;
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default managerOpenedClaimsReducer;
